// extracted by css-extract-rspack-plugin
export default {"header_search":"pJlEivx9SwDboGCJ"};